import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_appropriate_equipment_fight_fires_including_correct_ppe'

export const dataPointDefinition = {
  retracedId: 'no_appropriate_equipment_fight_fires_including_correct_ppe',
  name: 'No appropriate equipment to fight fires (including the correct PPE, e.g., breathing apparatus) available for members of ',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-eme-48x',
      number: 'HS-EME-22-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-eme-46',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-eme-11,Yes',
      machineShowHide: '[2],hs-eme-11,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-48x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30920,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
